import React, { Component } from 'react';
import jQuery from 'jquery';
 
import AdminLayout from './layout';

import { getLeads, 
        getLeadDetail, 
        getWebsiteAds, 
        getPartnerLeadInfo, 
        submitAdsEntryOther, 
        uploadOtherAd,
        deleteOtherAdEntry, makeWebP} from '../../API/FetchCall';

import { MOBILE_REGEX, URL_REGEX,IMGBASEURL } from '../../constant.js';
import FetchCall from '../../API/FetchCall';
import Geocode from "react-geocode";
import $ from 'jquery';
import moment from 'moment';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();

class cmsWebAds extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            lead:"",
            lead_data:[],
            partnerlist:[],
            ads:[],
            created_date:"",
            aid:'',
            display_in:'all',
            display_mode:'web',
            display_position:'R1',
            adstatus:"1",
            auth_data: JSON.parse(localStorage.getItem("user_data")),
            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
        }
        
        this.onFileUploadBanner = this.onFileUploadBanner.bind(this);
        this.getOtherAds = this.getOtherAds.bind(this);
        this.removeAd = this.removeAd.bind(this);
    }

    handleChange = (e) => {
      const propName = e.target.name;
      this.setState({ [e.target.name]: e.target.value });
    };

    handleFileMultiple = (e) => {
      const propName = e.target.name;
      var files = e.target.files;
      if (files.length > 3) {
        files = '';
        let toastr = window.toastr.error; //warning
        toastr('', 'Select 3 Images Only', {
          positionClass: "toast-bottom-right",
          containerId: "toast-bottom-right"
        });
      }
      this.setState({
        [propName]: files
      });
    };

    getOtherAds() {

        getWebsiteAds().then((response) => {
          if (response.status === 1) {
            this.setState({
                ads: response.list
            })
          }else{
            this.setState({
                ads: []
            })
          }
        });

    }

    onFileUploadBanner = (event) => {
    
      let toastr = '';
      // Details of the uploaded file
      const formData = new FormData();
      const banner_data = this.state.adbanner;

      for (let i = 0; i < banner_data.length; i++) {
        formData.append('adbanner', banner_data[i]);
      }

      uploadOtherAd(formData).then((response) => {
        
          if(response.status==1){
            
            NotificationManager.success('Image uploaded');
            this.setState({adbanner:response.files});

          }else{
            NotificationManager.error('Error in Image uploading');
            //alert("Error in Image uploading");
          }

        
      });
    };

    componentDidMount() {

        let user_data = localStorage.getItem("user_data");
        let auth_data = JSON.parse(user_data);
        let vendor_id = auth_data.login_id;
        this.setState({ vendor_id: vendor_id });
        this.getOtherAds();    
    }

    removeAd(ad_id){
        
        let toastr = '';

        let req = JSON.stringify({
          aid:ad_id           
        })

        deleteOtherAdEntry(req).then((response) => {

            if(response.status==1){

                this.getOtherAds(); 

                toastr = window.toastr.success;
                toastr('Ad is removed successfully', {
                  positionClass: "toast-bottom-right",
                  containerId: "toast-bottom-right"
               });

            }
        })
       
    }

    genWebp(ad_id){
        
      let toastr = '';

      let req = JSON.stringify({
        aid:ad_id           
      })

      makeWebP(req).then((response) => {

          if(response.status==1){

            alert("Created");

          }
      })
     
  }

    savead(){
        
      let toastr = '';
        
      let req = JSON.stringify({
          aid:this.state.aid,  
          adfilepath: this.state.adbanner,
          adname: this.state.adname,
          link: this.state.link,
          adstatus:this.state.adstatus,
          display_in:this.state.display_in,
          display_mode:this.state.display_mode,
          expiration:this.state.expiration,
          display_position:this.state.display_position
      })

      submitAdsEntryOther(req).then((response) => {

          if(response.status==1){

           alert("Ad is saved");

           this.getOtherAds();  

          }else{
              
           alert("Error saving Ad");    


          }
        
      });
    }

    showImage(image){



    }

    render() {

        const { ads } = this.state;
        //const IMGBASEURL = 'http://localhost:5005/';
        
        return (
            <React.Fragment>


              <AdminLayout>

              <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Advertisements</h4>

                <div class="row">         
                      
                    <div class="col-md-12 col-sm-12 col-xs-12">  

                    <div class="panel panel-default">
                        <div class="panel-heading clearfix">
                          <i class="icon-calendar"></i>
                          <h4 class="panel-title">List of Ads</h4>
                        </div>
        
                        <div class="panel-body">
                                <div class="tablerow">
                                 <table class="table table-bordered table-sm">
                                     <thead  class="thead-dark">
                                    <tr>
                                        <th>Ad Title</th>
                                        <th>Ad Image</th>
                                        <th>Ad Date</th>
                                        <th>Ad Status</th>
                                        <th>Display Mode</th>
                                        <th>Expire on</th>
                                        <th>Display In</th>
                                        <th>Position</th>
                                        <th>Action</th>
                                    </tr>
                                        </thead>

                                 {  ads.map((ad, i) => {

                                    return <tr >
                                             <td >{ad.adname}</td>
                                             <td ><button onClick={()=>this.showImage(''+IMGBASEURL+"uploads/"+ad.adfilepath+'')}>Clike to view</button></td>
                                             <td >{new Date(Number(ad.created_at)).toString().substring(4, 15)}</td>
                                             <td >{(ad.adstatus==1)?"Active":"Inactive"}</td>
                                             <td >{ad.display_mode}</td>
                                             <td >{ad.expiration}</td>
                                             <td >{(ad.display_in=='tuitionblog')?'Blogs of Tuitions': (ad.display_in=='schoolblog')? 'Blogs of School':(ad.display_in=='afterschoolblog')?'Blogs of After School':(ad.display_in=='defaultblog')?'Default in Blogs':ad.display_in}</td>

                                             <td >{ad.display_position}</td>
                                             <td><button class="btn btn-primary btn-sm" onClick={()=>this.removeAd(ad.aid)}>Remove</button>&nbsp;<button class="btn btn-primary btn-sm" onClick={()=>this.genWebp(ad.aid)}>Webp</button></td>
                                            </tr>

                                }) }

                                 {ads.length==0 &&

                                 <tr><td colSpan="5">No data</td></tr>

                                 }
                                 </table>
                                </div>

                        </div>
                    </div>

                    </div>

                </div>

                
                <hr/>
             

                <div class="row form">

                <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="panel panel-default">
        <div class="panel-heading clearfix">
          <i class="icon-calendar"></i>
          <h4 class="panel-title">Create Ad</h4>
        </div>
        
        <div class="panel-body">

          <div class="row p-3">
            <div class="col-lg-4 col-sm-12">
              <div class="input-group input-group-sm">
              <label for="brochure">Ad Name</label>
              <input type="text" name="adname" class="form-control input-sm" onChange={this.handleChange}/>
              </div>
            </div>
            <div class="col-lg-8 col-sm-12">
              <div class="input-group input-group-sm">
                <label for="brochure">Hyperlink to click</label>
                <input type="text" name="link" class="form-control input-sm" onChange={this.handleChange}/>
              </div>
            </div>
          </div>
          <br/>
          <div class="row p-3">
            <div class="col-md-4">
              <div class="input-group input-group-sm">
              <label for="brochure">Display in</label>
                    
                    <select name="display_in" class="form-control input-sm" onChange={this.handleChange}>
                        <option value="all">BeWise Website</option>
                        
                        <option value="tuitionblogs">Tuition related Blog Pages</option> 
                        <option value="schoolblogs">School related Blog Pages</option> 
                        <option value="skillblogs">Skill related blog pages (yoga, abacus,vedic math, balvihar, coding ..etc)</option> 
                        <option value="danceblogs">Dance related blog pages (kathak, bharathanatyam, kucchipudi, odissi ..etc)</option>
                        <option value="sportsblogs">Sports related blog pages (football, tennis, cricket, swimming..etc)</option>
                        <option value="musicblogs">Music related blog pages (vocal and Instruments)</option>
                        <option value="artsblogs">Arts related blog pages (drawing, pottery and arts & crafts)</option> 
                        <option value="hobbiesblogs">Hobbies related blog pages (cooking, story telling and quiz)</option> 
                        <option value="defaultblog">Default Blog Pages</option> 
                        <option value="listing">All Vertical listing Pages</option> 
                        <option value="school">School Listing Page</option> 
                        <option value="preschool">Preschool Listing Page</option> 
                        <option value="afterschool">After School Listing Page</option> 
                        <option value="tuition">Tuition Listing Page</option>
                        <option value="camps">Learning Camps Listing Page</option>
                        <option value="kidsplayarea">Kids Play Area Listing Page</option>
                        <option value="community">Community Support Listing Page</option>
                    </select>

                    
              </div>
            </div>
            <div class="col-md-3">
              <div class="input-group input-group-sm">
              <label for="brochure">Display Position</label>
                    
                    <select name="display_position" class="form-control input-sm" onChange={this.handleChange}>
                        <option value="R1">Right SideBar Position #1</option>
                        <option value="R2">Right SideBar Position #2</option> 
                        <option value="BT">Bottom</option> 
                        <option value="TOP">Top</option> 
                        
                    </select>

                    
              </div>
            </div>
            <div class="col-md-3">
              <div class="input-group input-group-sm">
              <label for="brochure">Display Mode</label>
                    
                    <select name="display_mode" class="form-control input-sm" onChange={this.handleChange}>
                        <option value="web">Web</option>
                        <option value="mobile">Mobile</option> 
                        
                    </select>

                    
              </div>
            </div>
            

          </div>

          <div class="row p-3">
          <div class="col-md-4">
                 <label for="brochure">Ad Status</label>
                 <br/>
                    <label class="radio-inline">
                    <input type="radio"  name="adstatus" value="1" onChange={this.handleChange} checked />Enabled
                    </label>
                    <label class="radio-inline">
                    <input type="radio"  name="adstatus" value="0" onChange={this.handleChange}/>Disabled
                    </label>
            </div>

            <div class="col-md-4">
                 <label for="brochure">Expiration</label>
                 <input type="date" name="expiration" class="form-control input-sm" onChange={this.handleChange}/>
            </div>
          </div>
          <br/>
          <div class="row p-3">
            <div class="col-lg-4 col-sm-12">
                   <div class="input-group input-group-sm">
                      <label for="banner">Ad Banner (112 × 600 OR 468 x 60 in px)(jpgs)</label>
                      <div class="row">
                      <div class="col-md-6 col-sm-6 col-xs-12"><input type="file" name="adbanner" multiple class="form-control input-sm" placeholder="Ad Banners" onChange={this.handleFileMultiple}/></div>
                      <div class="col-md-6 col-sm-6 col-xs-12"><button class="btn btn-primary btn-sm" onClick={this.onFileUploadBanner}>
                          Upload!
                      </button></div>
                      </div>
                   </div>
            </div>
          </div>
          <br/>
          <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-12">
                        <button type="button" class="btn btn-primary" onClick={()=>this.savead()}>Save Ad</button>
                    </div>
          </div>

        </div>


      </div>
            </div>



                </div>

                

                                
                            
                        </div>
                    </div>
                </div>
                </AdminLayout>
            </React.Fragment>
        )
    }
}

export default cmsWebAds;


// WEBPACK FOOTER //
// ./src/components/bewise/webAds.jsx